import React from 'react'
import { observer } from "mobx-react";
import { useStores } from "../../stores/rootStore";
import { Container, Button, Tabs, Tab } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';


export const QARFormManagers = observer(() => {

  const { qarFormStore } = useStores();

  const handleManagerChange = async (managerId: string) => {
    await qarFormStore.saveChangedQarManagerData(qarFormStore.selectedManagerId!);
    qarFormStore.selectedManagerId = managerId

    if (qarFormStore.qarFormManagerData?.some(x => x.managerId === managerId)) {
      await qarFormStore.saveChangedQarManagerData(managerId);
      await qarFormStore.loadCurrentQarManagerData(managerId);
    }
    else {
      await qarFormStore.loadEmployees(managerId)
      await qarFormStore.loadDelegatedUnmatchedAccounts(managerId)
    }
  }

  const renderManager = () => {
    if (qarFormStore.manager === undefined) {
      return (
        <Container>
          <Skeleton variant="text" width="20%" style={{ margin: "10px 0", display: "inline-block" }} />
        </Container>
      );
    }

    if (qarFormStore.manager === null) {
      return <></>
    }

    if (qarFormStore.selectedManagerId && qarFormStore.manager.id === qarFormStore.selectedManagerId) {
      return <Button variant="contained" color="primary">{qarFormStore.manager?.fullNames}</Button>
    }

    return (
      <Button variant="contained" color="default" onClick={() => qarFormStore.manager && handleManagerChange(qarFormStore.manager.id)}>
        {qarFormStore.manager.fullNames}
      </Button>
    );
  }

  const renderMyManagers = () => {

    if (!qarFormStore.manager || qarFormStore.manager.myManagers.length === 0) {
      return false;
    }

    let value: string | boolean = false;
    if (qarFormStore.selectedManagerId && qarFormStore.manager.id !== qarFormStore.selectedManagerId) {
      value = qarFormStore.selectedManagerId;
    }

    return (
      <Tabs value={value} onChange={async(_, v) => handleManagerChange(v)} variant="scrollable"
        scrollButtons="auto" aria-label="scrollable auto tabs" style={{ paddingTop: "0px" }}>
        {qarFormStore.manager.myManagers.map(manager => {
          return (<Tab key={manager.id} value={manager.id} label={manager.fullNames} />);
        })}
      </Tabs>
    );
}

  return (
    <div id="qar-form-managers-wrapper" className="organization" style={{ paddingTop: "0px" }}>
      {renderManager()}
      {renderMyManagers() ? <span className="myManagers">{renderMyManagers()}</span> : <></> }
    </div>
  );

});